<template>
  <v-container fluid>
    <register-member v-if="$currentUrl === 'NewMember'"> </register-member>
    <edit-member v-if="$currentUrl === 'Member'"></edit-member>
  </v-container>
</template>

<script>
  import RegisterMember from '../../Public/Pages/RegisterMember'
  import EditMember from '../../Back/Membership/EditMember'

  export default {
    name: 'NewMember',
    components: { RegisterMember, EditMember },
    data() {
      return {}
    }
  }
</script>

<style>
</style>
